import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '@service/notification.service';
import { LanguageService } from '@service/language.service';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from '@service/apiv6.service';
import { CommonService } from '@service/common.service';
import { getDataFromStorage } from '@core/_utils/tools.utils';
import { AuthService } from '@auth/auth.service';
import { DocumentService } from '@service/document.service';
import { DownloadService } from '@service/download.service';

@Component({
    selector: 'notifications',
    templateUrl: 'notifications.component.html',
    styleUrls: ['notifications.component.scss'],
})
export class NotificationsComponent {
    public notifList = [];
    public notifStatList = [];
    public notifDocList = [];
    public notifMsgList = [];    
    public currentNotifList = [];    
    public activeIndex = 0;
    public message = '';
    public visibleNotif = false;
    public showNotif = 'false';
    public messageData;
    public destUser= '';
    public pathPdf='';
    public userList: any[];
    public currentData: any;
    public currentUser;
    public userInfos;
    public isAdmin = false;
    public tabs: any[] = [];
    public docId = '';

    // Type de notification :
    // 0 : Statistiques disponibles
    // 1 : Pdfs disponibles
    // 2 : Copies zip disponibles
    // 3 : Originaux zip disponibles
    // 4 : Message de (lié à un document)
    // 5 : Zdocs disponibles
    // 6 : Message

    constructor(private _translate: TranslateService, public languageService: LanguageService,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        private commonService: CommonService,
        public notifService: NotificationService,
        private auth: AuthService,
        private documentService: DocumentService,
        private downloadService: DownloadService
        ) {
            this.userList = [];
            let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
            this.userInfos = wInternal.internal;
            this.showNotif = wInternal.allowSendNotif;
        }

    public ngOnInit() {
        this.isAdmin = this.auth.isAdmin();
        this.currentUser = this.auth.getUser();
        this.tabs.push({title: this._translate.instant('all')});
        this.tabs.push({title: this._translate.instant('Stat')});
        this.tabs.push({title: this._translate.instant('Export_N')});
        this.tabs.push({title: this._translate.instant('Message_N')});
        this.setNotifList();        
    }

    public ngOnChanges() {
    }

    ngOnDestroy() {
    }

    public setNotifList() {
        this.notifList = [];
        this.notifStatList = [];
        this.notifDocList = [];
        this.notifMsgList = []; 
        this.notifService.notifList = getDataFromStorage('notifylist');        

        this.notifService.notifList.forEach(item => {
            switch (item.typenotif) {
                case 0:
                    this.notifStatList.push(item);
                    break;
                case 1:
                case 2:
                case 3:
                case 5:
                    this.notifDocList.push(item);
                    break;
                case 4:
                case 6:                    
                    item.mess = item.datanotif;
                    item.answer = false;
                    this.notifMsgList.push(item);
                    break;                    
            }
        });
        this.notifList = [...this.notifStatList, ...this.notifDocList];
        this.notifList = [...this.notifList,...this.notifMsgList];
        this.currentNotifList = [...this.notifList];
        this.tabs[0].currentNotifList = this.notifList;
        this.tabs[1].currentNotifList = this.notifStatList;
        this.tabs[2].currentNotifList = this.notifDocList;
        this.tabs[3].currentNotifList = this.notifMsgList;
    }

    public async onDownLoad(event, rowData) {
        let wtype;
        let filename = rowData.datanotif;
        let wRequest = {
            BatchResult: true,
            BatchName: rowData.datanotif,
        };    
        await this.downloadService.downLoadBatch(wRequest, wtype, filename);
    }

    public async onDelete(event, rowData) {
        let wRes: any;
        // Suppression de la notification
        wRes = await this.notifService.deleteNotify(rowData.id);
        // Maj de la liste        
        wRes = await this.notifService.updateStoreList(rowData.id);
        this.setNotifList();
    }

    public async onAnswer(event, data, aIndex) {
        let wRes: any;
        let wUser: any;
        if (this.userList.length === 0) {
            try {
                await this.commonService.getUserList(this.userList);           
            } catch (error) {
                console.log('Error', error);
                this._messageService.addErrorMsg(this._translate.instant('Load_Data_KO'));
                return;
            }
        }
        this.docId = this.notifMsgList[aIndex].docid;
        // setTimeout(() => {
            this.pathPdf = this.api.getPdf(this.notifMsgList[aIndex].docid);
        // }, 100);
        this.currentData = data;
        wUser = this.notifService.getDestUser(this.currentData.fromlogin, this.userList);
        if (wUser !== undefined || wUser !== null) {
            this.destUser = wUser.displayValue;
        }
        this.visibleNotif = true;
    }    

    public async onCheck(event, data, aIndex) {
        this.currentData = data;
        // Fin notification
        await this.onClickEnd();
    }

    public async onClickSend($event) {
        let wRes: any;
        if ($event.comment.trim() === '') {
            return;
        }
        // Maj du commentaire
        this.documentService.setDocId(this.currentData.docid);
        this.documentService.comment = $event.comment;
        wRes = await this.documentService.saveComment(this.userInfos);
        if (wRes === false) {
            this._messageService.addErrorMsg(this._translate.instant('Update_KO'));
            return;
        }

        $event.id = this.currentData.id;
        $event.fromUser = this.currentData.login;
        $event.destUser = [this.notifService.getDestUser(this.currentData.fromlogin, this.userList)];

        const wData = {
            data: this.notifService.getFromUser(this.isAdmin, this.userList, this.currentUser),
            destuser: [this.notifService.getDestUser(this.currentData.fromlogin, this.userList)],
            fromUser: this.currentData.login,
            docid: this.currentData.docid,
        }

        // Ajout de la notification au destinataire (réponse)
        wRes = await this.notifService.addNotification(wData);
        if (wRes.Status === 'OK') {
            this._messageService.addInfo(this._translate.instant('Notif_Send_OK'));            
        } else {
            this._messageService.addErrorMsg(this._translate.instant('Update_KO'));
        }

        // Fin notification
        await this.onClickEnd();
    }

    public async onClickEnd() {
        let wRes: any;
        const wData = {
            id: this.currentData.id,
        }
        wRes = await this.endActionNotify(wData);
        this.visibleNotif = false;
    }

    private async endActionNotify(aData) {
        let wRes: any;
        // Maj de statenotif (notification terminée)
        wRes = await this.notifService.endNotify(aData);
        // Maj de la liste
        wRes = await this.notifService.updateStoreList(aData.id);
        this.setNotifList();
    }
}
